export function isAdmin(currentUser: UserSnakeModel) {
  return currentUser && currentUser.type === "Admin";
}

export function canPossiblyAccess(currentRoleDefinition: RoleDefinitionSnakeModel, ...args: Array<any>) {
  return !!lookupInDefinition(currentRoleDefinition, ...args);
}

function lookupInDefinition(currentRoleDefinition: RoleDefinitionSnakeModel, ...args: Array<any>) {
  const result = args.reduce((definition, arg) => definition === true || (typeof(definition) === "object" && definition[arg]), currentRoleDefinition.temp_definition);
  return result || false;
}
